export default "__VITE_PUBLIC_ASSET__0df1cdb7__"